module.exports = __webpack_public_path__ + "static/media/05-11.b7665cc4.png";